(function () {
  class FullWinningsDisplay extends PIXI.Container {
    constructor(standardThresholds, buyABonusThresholds, landscapeData, portraitData) {
      super();
      this._completeCallback;
      StateMachine.Create(this);
      this._standardThresholds = standardThresholds;
      this._buyABonusThresholds = buyABonusThresholds;
      this._positionData = undefined;
      this._finalWinDisplayTime = 0;

      this.onLayoutChangeCB = this.onLayoutChange.bind(this);

      messageBus.subscribe('stake:stakeChanged', this.onStakeChanged.bind(this));
    }

    initialise() {
      this._jsonPath = this.name + ':fullWinningsDisplayContainer';
      this._darkOverlay = undefined;
      this._spineContainer = undefined;
      this._winningsAmount = undefined;
      this._skipButton = undefined;
      this._countUpTimeline = undefined;
      this._outroTimeline = undefined;
      this._totalWinnings = 0;
      this._currentStake = 0;
      this._bigWinLevel = -1;
      this._bigWinLevelTracker = 1;
      this._smallWinCountupTime = 1;
      this._bigWinCountUpTime = 11;
      this._winsSkippedThisSpin = false;
      this._displayPhase = 0; // 0 = before, 1 = count up, 2 = outro
      this._outroDisplayedThisSpin = false;
      this._levelNames = ['Nice', 'Big', 'Huge', 'Massive', 'Epic', 'Pigtastic'];

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:SpinEvent', this.onDoSpin.bind(this));
    }

    onDoSpin() {
      this._winsSkippedThisSpin = false;
      this._displayPhase = 0;
      this._outroDisplayedThisSpin = false;
    }

    onLayoutChange() {
      this.skipPressed(false);
    }

    onGameConfigEvent(task) {
      this._completeCallback = undefined;

      this._spineAnim = resourceManager.createObject('spine', 'bigWinSpine', this._jsonPath + ':spineContainer', {
        name: 'BigWin',
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      });
      this._spineAnim.visible = false;

      this._darkOverlay = resourceManager.get(this._jsonPath + ':panelMask');
      this._darkOverlay.visible = false;

      this._skipButton = resourceManager.get('fullScreenSkipButton');
      this._skipButton.interactive = false;
      this._skipButton.mousedown = this._skipButton.touchstart = this.fullScreenSkipPressed.bind(this);

      this._winningsAmount = resourceManager.get(this._jsonPath + ':cashWon');
      this._winningsAmount.visible = false;

      this._coinEmitter = particleManager.createEmitter(
        'win_display_coin',
        this._jsonPath + ':particleContainer',
        0,
        0,
        false
      );
      this._coinEmitter.particleEmitter.emit = false;
    }

    onStakeChanged() {
      const stakeController = resourceManager.getController('stakeController');
      this._currentStake = stakeController.BaseStake;

      this._currentStake = gameController.getCurrentModeStake();
    }

    setWinningsText(amount) {
      const text = gdk.formatCurrency(amount, false);
      this._winningsAmount.setText(text);
    }

    displayWinnings(
      winnings,
      inFreeSpins,
      callback,
      buyBonus = false,
      stake = this._currentStake,
      allowSkip = false,
      finalFreeSpins = false
    ) {
      Reflex.registerEventHandler('layoutChange', this.onLayoutChangeCB);

      this._completeCallback = callback;
      this._countUpTimeline = undefined;
      this._outroTimeline = undefined;
      this._totalWinnings = winnings;
      this.setWinningsText(0);
      let lowWin = true;
      this._finalWinDisplayTime = 0.75;
      this.buyBonus = buyBonus;
      this.providedStake = stake;
      this.finalFreeSpins = finalFreeSpins;

      if (winnings > this._currentStake) {
        lowWin = false;
        this._finalWinDisplayTime = 1.0;
      } else {
        this.setWinningsText(winnings);
      }
      this._bigWinLevel = -1;

      let thresholds = buyBonus ? this._buyABonusThresholds : this._standardThresholds;

      for (let i = 0; i < thresholds.length; i++) {
        if (winnings >= thresholds[i] * stake && !inFreeSpins) {
          this._bigWinLevel = i;
          this._finalWinDisplayTime = 2;
        }
      }

      if (this._bigWinLevel !== -1) {
        this._darkOverlay.alpha = 0;
        this._darkOverlay.visible = true;
      }

      this._displayPhase = 1;

      if (this._winsSkippedThisSpin) {
        this.skipPressed(false);
        if (this._bigWinLevel === -1) {
          this.cleanUp();
        } else {
          this.displayFinalWinnings();
        }
      } else {
        if (this._bigWinLevel === -1) {
          this.doSmallWin(lowWin);
        } else {
          if (allowSkip === true) {
            this._skipButton.interactive = true;
          }
          this.doBigWin();
        }
      }
    }

    doSmallWin(lowWin) {
      this._skipButton.interactive = true;

      if (!lowWin) {
        soundManager.play('countupCoinLoop');
        this._coinEmitter.particleEmitter.emit = true;
      }

      this.doCountUp(this._smallWinCountupTime, lowWin);
    }

    doBigWin() {
      musicManager.playBigWin();

      this._bigWinLevelTracker = 0;

      const introTime = 0.5;

      gsap.to(this._darkOverlay, {
        duration: introTime,
        alpha: 1,
        ease: 'none',
        onComplete: () => {
          if (!this._winsSkippedThisSpin) {
            soundManager.play('countupCoinLoop');
            this._coinEmitter.particleEmitter.emit = true;
            this.doCountUp(this._bigWinCountUpTime, false, true);
          }
        },
      });

      this._spineAnim.visible = true;
      this._spineAnim.alpha = 1;
      this._spineAnim.spineObject.state.clearListeners();
      this._spineAnim.play('0-Nice_Win_Start', false, 0, () => {
        this.doLevelUps();
      });
    }

    doLevelUps() {
      const levelName = this._levelNames[this._bigWinLevelTracker];

      if (this._bigWinLevel === this._bigWinLevelTracker) {
        this._spineAnim.spineObject.state.clearListeners();
        this._spineAnim.play(`${this._bigWinLevelTracker}-${levelName}_Win_Loop`, true, 0);
      } else {
        if (this._bigWinLevelTracker < this._levelNames.length) {
          const nextLevel = this._levelNames[this._bigWinLevelTracker + 1];

          // we ideally need to switch level when we get to the threshold on the count up
          // not when the loop anim has finished
          this._spineAnim.spineObject.state.clearListeners();
          this._spineAnim.play(`${this._bigWinLevelTracker}-${levelName}_Win_Loop`, true, 0);
        }
      }
    }

    doCountUp(time, lowWin, ignoreCountUp = false) {
      if (lowWin) {
        soundManager.play('winCountUpWhenLowWin');
      } else {
        if (!ignoreCountUp) {
          soundManager.play('winCountUp');
        }
      }

      this._winningsAmount.visible = true;
      this._winningsAmount.alpha = 0;

      let obj = { count: 0 };

      console.log('zz do count up, time', time);

      this._countUpTimeline = gsap
        .timeline()
        .to(this._winningsAmount, {
          duration: 0.15,
          alpha: 1,
        })
        .to(
          obj,
          {
            duration: time,
            count: this._totalWinnings,
            ease: 'none',
            onUpdate: () => {
              if (lowWin) {
                this.setWinningsText(this._totalWinnings);
              } else {
                if (!this._winsSkippedThisSpin) {
                  const thresholds = this.buyBonus ? this._buyABonusThresholds : this._standardThresholds;
                  // using this._bigWinLevelTracker, work out if the count has reached the threshold
                  const perc = 0.95; // perhaps different % based on the level?
                  // this perc means we can start the transition a little earlier
                  if (
                    this._bigWinLevelTracker < this._bigWinLevel && //
                    obj.count >= thresholds[this._bigWinLevelTracker + 1] * perc * this.providedStake
                  ) {
                    // time to switch it up
                    const levelName = this._levelNames[this._bigWinLevelTracker];
                    const nextLevelName = this._levelNames[this._bigWinLevelTracker + 1];
                    this._bigWinLevelTracker++;
                    musicManager.playBigWinUpgrade();
                    this._spineAnim.play(
                      `${this._bigWinLevelTracker - 1}-${levelName}-${nextLevelName}-Transition`,
                      false,
                      0,
                      () => {
                        if (!this._winsSkippedThisSpin) {
                          this.doLevelUps();
                        }
                      }
                    );
                  }
                }

                this.setWinningsText(obj.count);
              }
            },
            onComplete: () => {
              console.log('zz complete');
              if (lowWin) {
              } else {
                if (!ignoreCountUp) {
                  soundManager.stop('winCountUp');
                }
              }

              this.displayFinalWinnings();
            },
          },
          '<'
        );
    }

    displayFinalWinnings() {
      if (this._outroDisplayedThisSpin) {
        return;
      }

      this._skipButton.interactive = false;

      if (this._bigWinLevel >= 0) {
        musicManager.playBigWinEnd();
      }

      soundManager.stop('winCountUp');

      if (this._bigWinLevel !== -1) {
        this._darkOverlay.alpha = 1;
        this._darkOverlay.visible = true;
      }

      this._winningsAmount.visible = true;
      this._winningsAmount.alpha = 1;

      this.setWinningsText(this._totalWinnings);

      soundManager.stop('countupCoinLoop');
      this._coinEmitter.particleEmitter.emit = false;
      this._countUpTimeline = undefined;

      this._displayPhase = 2;

      this.delay(this._finalWinDisplayTime, () => {
        this.doOutro();
      });
    }

    doOutro() {
      this._outroDisplayedThisSpin = true;

      let outroTime = 0.25;
      soundManager.stop('countupCoinLoop');
      this._coinEmitter.particleEmitter.emit = false;

      gsap.to(this._winningsAmount, {
        duration: 0.15,
        alpha: 0,
      });

      if (this._bigWinLevel !== -1) {
        this._outroTimeline = gsap.to([this._darkOverlay, this._spineAnim], {
          duration: outroTime,
          alpha: 0,
          ease: 'none',
          onComplete: () => {
            this._darkOverlay.visible = false;
            this._darkOverlay.alpha = 1;
            this._spineAnim.alpha = 1;
            this._spineAnim.visible = false;
            this.cleanUp();
          },
        });
      } else {
        this.cleanUp();
      }
    }

    delay(time, callback) {
      this._outroTimeline = gsap.delayedCall(time, callback);
    }

    fullScreenSkipPressed() {
      if (gameController.canSkipWin || this.finalFreeSpins) {
        this.skipPressed();
      }
    }

    skipPressed(playAudio = true) {
      const canSkipWin = gameController.canSkipWin;
      gameController.canSkipWin = false;
      this._winsSkippedThisSpin = true;
      this._skipButton.interactive = false;

      if (this._bigWinLevel !== -1) {
        this._bigWinLevelTracker = this._bigWinLevel;

        const levelName = this._levelNames[this._bigWinLevelTracker];
        this._spineAnim.spineObject.state.clearListeners();
        this._spineAnim.play(`${this._bigWinLevelTracker}-${levelName}_Win_Loop`, true, 0);
        this._spineAnim.visible = true; // make sure we are visible
      }

      if (this._displayPhase === 0) {
        if (canSkipWin) {
          gameController.skipWin();
        }
      }

      if (this._displayPhase === 1) {
        if (gameController.lowWinTimer) {
          timerManager.stop(gameController.lowWinTimer, true);
          gameController.lowWinTimer = undefined;
        }

        if (this._countUpTimeline !== undefined) {
          this._countUpTimeline.kill();
        }

        if (this._bigWinLevel === -1) {
          this.cleanUp();
        } else {
          this.displayFinalWinnings();
        }
      }
    }

    cleanUp() {
      Reflex.deregisterEventHandler('layoutChange', this.onLayoutChangeCB);
      this._bigWinLevelTracker = 0;
      this._skipButton.interactive = false;
      this._darkOverlay.visible = false;
      this._darkOverlay.alpha = 0;
      this._spineAnim.visible = false;
      this._winningsAmount.visible = true;
      this._winningsAmount.alpha = 0;
      this._winningsAmount.setText('');

      soundManager.stop('winCountUp');
      soundManager.stop('countupCoinLoop');
      this._coinEmitter.particleEmitter.emit = false;
      this._spineAnim.stop();

      this._winsSkippedThisSpin = false;
      this._displayPhase = 0;
      this._outroDisplayedThisSpin = false;

      if (this._completeCallback) {
        this._completeCallback();
        this._completeCallback = undefined;
      }
    }

    willTriggerBigWin(winnings, buyBonus = false, stake = this._currentStake) {
      let threshold = buyBonus ? this._buyABonusThresholds[0] : this._standardThresholds[0];

      if (winnings >= threshold * stake) {
        return true;
      } else {
        return false;
      }
    }
  }

  create = function (json) {
    return new FullWinningsDisplay(json.standardThresholds, json.buyABonusThresholds);
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('fullWinningsDisplay', create, initialise, getFilesRequired);
})();
